import { createTheme, rem } from '@mantine/core';

/**
 * Mantine theme mapped to the design tokens in tokens.css: a dense UI with a
 * warm neutral palette, running one step up from a 12–13px base (see the
 * type-scale note in tokens.css).
 *
 * Font stacks live in tokens.css (--rr-font / --rr-font-mono) so the theme and
 * the hand-written CSS cannot drift apart.
 */
export const theme = createTheme({
  fontFamily: 'var(--rr-font)',
  fontFamilyMonospace: 'var(--rr-font-mono)',
  // rem, not px: Mantine's variables resolver assigns these verbatim, so a px
  // string here would never respond to the reader's browser font size.
  fontSizes: {
    xs: rem(12),
    sm: rem(13.5),
    md: rem(14.5),
    lg: rem(16),
    xl: rem(18),
  },
  defaultRadius: 'md',
  primaryColor: 'blue',
  headings: {
    fontFamily: 'var(--rr-font)',
    fontWeight: '700',
  },
});
